import { UseQueryStateResult } from '@reduxjs/toolkit/dist/query/react/buildHooks.d'
import { createApi } from '@reduxjs/toolkit/query/react'

import { PannellumDataInterface } from '@components/showcase-pannellum/types'

import baseQueryInterceptor from '@api/base-query-interceptor'
import { ApiResponse } from '@api/types/api-response.type'

type PanoramicTypeInterface = {
  projectName: string
  panoramaGroup?: string
}

export const panoramicApi = createApi({
  reducerPath: 'panoramicApi',
  baseQuery: baseQueryInterceptor,
  endpoints: (builder) => ({
    getPanoramic: builder.query<
      ApiResponse<Array<PannellumDataInterface>>,
      PanoramicTypeInterface
    >({
      query: (params: PanoramicTypeInterface) => ({
        url: '/v2/panoramas',
        method: 'get',
        params: {
          projectId: params.projectName,
          pagination: false,
          panoramaGroup: params.panoramaGroup,
        },
      }),
    }),
  }),
})

export const selectFromResult = ({
  data,
  isLoading,
  isError,
  status,
  error,
}: UseQueryStateResult<any, any>): {
  panoramicData: PannellumDataInterface[]
  isLoaded: boolean
  isError: boolean
  status: string
  errorStatus: number
} => ({
  panoramicData: data?.data?.data || [],
  isLoaded: !isLoading,
  isError,
  status,
  errorStatus: error?.status,
})

export const { useGetPanoramicQuery } = panoramicApi
